import { SkeletonBar, SkeletonParagraph } from '@givebutter/primitives/skeleton';

const SkeletonFiller = () => {
  return (
    <div className="flex flex-col gap-8 px-4 py-6">
      <div className="flex flex-col gap-2">
        <SkeletonBar className="w-48" />
        <SkeletonBar className="w-56" />
        <SkeletonBar className="w-36" />
      </div>
      <SkeletonBar className="h-4 w-48" />
      <div>
        <SkeletonParagraph />
      </div>
    </div>
  );
};

export { SkeletonFiller };
